import { useMount } from '@shared/utils/hooks/useMount';

import { MAX_ACQUISITION_CONTEXTS } from './acquisitionContextTracking.constants';
import { readAcquisitionContexts, writeAcquisitionContexts } from './acquisitionContextTracking.storage';
import { StoredAcquisitionContextDetails, StoredAcquisitionContextData } from './acquisitionContextTracking.types';

function saveCurrentAcquisitionContext(locationParam: Location, referrer: string): void {
  const acquisitionContextData: StoredAcquisitionContextData[] = [];
  const searchParams = new URLSearchParams(locationParam.search);
  searchParams.forEach((value, key) => {
    if (key && value) {
      acquisitionContextData.push({ key, value });
    }
  });

  const acquisitionContext: StoredAcquisitionContextDetails = {
    timestamp: Date.now(),
    relativeUrl: locationParam.pathname,
    referrer,
    data: acquisitionContextData
  };

  const newAcquisitionContexts = readAcquisitionContexts().concat(acquisitionContext);
  if (newAcquisitionContexts.length > MAX_ACQUISITION_CONTEXTS) {
    newAcquisitionContexts.shift();
  }

  writeAcquisitionContexts(newAcquisitionContexts);
}

export function useSaveCurrentAcquisitionContext(locationParam = window.location, referrer = document.referrer): void {
  useMount(() => {
    saveCurrentAcquisitionContext(locationParam, referrer);
  });
}
